/**
 * PUT/POST /tenantUser/product_service responses wrap the entity under `product_service`
 * and may include `template_updated_count` / `templated_updated` when document templates were impacted.
 */
export function unwrapProductServiceResponse(payload) {
  const raw = payload?.product_service ?? payload;
  const productService = Array.isArray(raw) ? raw[0] : raw;
  const templateUpdatedCount =
    Number(payload?.template_updated_count ?? payload?.templated_updated) || 0;
  return { productService, templateUpdatedCount };
}

export function getTemplateUpdatedToastMessage(templateUpdatedCount) {
  const count = Number(templateUpdatedCount) || 0;
  if (count <= 0) return null;
  return `Updating this product/service also updated ${count} template(s).`;
}
